import { render, staticRenderFns } from "./LargeAuth.vue?vue&type=template&id=6f49b4c5&"
import script from "./LargeAuth.vue?vue&type=script&lang=js&"
export * from "./LargeAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports